import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import * as _ from 'lodash';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/switchMap';

@Injectable()
export class RoleService {

  userRoles : Array<string>; // roles of currently logged in user

  constructor(private auth: AuthService,
              private db: AngularFireDatabase) {
                auth.user.map(user => {
                  /// Set an array of user roles, ie ['admin', 'author', ...]
                  return this.userRoles = _.keys(_.get(user, 'roles'))
                })
                .subscribe()

              }

  get getUserRoles() {
    return this.userRoles;
  }

  get isAdmin(): boolean {
      const allowed = ['admin']
      return this.matchingRole(allowed)
    }

  get isAgent(): boolean {
      const allowed = ['agent', 'admin']
      return this.matchingRole(allowed)
    }

  get isHomeowner(): boolean {
      const allowed = ['homeowner', 'admin']
      return this.matchingRole(allowed)
    }


  /// Helper to determine if any matching roles exist
  public matchingRole(allowedRoles): boolean {
    return !_.isEmpty(_.intersection(allowedRoles, this.userRoles))
  }

}



// WEBPACK FOOTER //
// ./src/app/providers/authRole.service.ts